/**
 *
 * FlashCardLanding
 *
 */

export const FlashCardItemMixin = {
  name: 'FlashCardItemMixin',

  props: {
    p_isDisabled: {
      type: Boolean,
      default: () => false,
    },
  },
};
